import clsx from "clsx";
import { motion } from "framer-motion";
import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ReactComponent as ArrowLeftIcon } from "src/assets/icons/arrow-left.svg";
import { ReactComponent as CloseIcon } from "src/assets/icons/close.svg";
import { tokens } from "src/locales/tokens";
import Typography from "../typography";

interface LayoutProps {
	children: React.ReactNode;
	transparent?: boolean;
	avatarIcon?: React.ReactNode;
	headerClassName?: string;
	gradientHeaderNavButton?: boolean;
	className?: string;
	title?: React.ReactNode;
	showHeader?: boolean;
	closeButton?: boolean;
	overflow?: boolean;
	backButton?: boolean;
	paddingHorizontal?: boolean;
	onClickClose?: () => void;
	rightButton?: React.ReactNode;
	leftButton?: React.ReactNode;
}

export default function Layout({
	className,
	rightButton,
	transparent,
	children,
	title,
	avatarIcon,
	overflow = true,
	paddingHorizontal = true,
	onClickClose,
	closeButton = false,
	backButton = true,
	leftButton,
	showHeader = true,
}: // ...props
LayoutProps) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	return (
		<motion.div
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			initial={{ opacity: 0 }}
			whileInView={{ opacity: 1 }}
			className={clsx(
				"relative flex size-full flex-1 flex-col items-start justify-start bg-[#f5f5f5]",
			)}
		>
			{/* <main
        className={clsx(
          className,
          'mt-3 px-3  md:mt-5 lg:mt-10 lg:px-0', //todo check this margintop
          showFooter && ' pb-10  lg:pb-32 ',
          'container mx-auto  bg-gray-800'
        )}
      > */}

			<main
				className={clsx(
					"relative mx-auto flex h-screen w-full max-w-md flex-1 flex-col",
					overflow ? "overflow-auto" : "overflow-hidden",
					className,
				)}
			>
				{showHeader && (
					<div
						className={clsx(
							"fixed top-0 z-50 mx-auto flex max-w-md items-center justify-between bg-[#f5f5f5] px-4",
							transparent
								? "inset-x-0 top-0 h-16 bg-[#f5f5fb]"
								: "inset-x-5 top-5 h-14 rounded-2xl bg-white",
						)}
					>
						{/* <button type="button" onClick={() => router.back()}>
              <Icon icon="solar:arrow-left-linear" />
            </button> */}

						{backButton ? (
							<ArrowLeftIcon
								className="z-50 stroke-gray-900"
								onClick={() => {
									if (onClickClose) onClickClose();
									else navigate(-1);
								}}
							/>
						) : closeButton && onClickClose ? (
							<button
								className="z-50 flex items-center space-x-2"
								type="button"
								onClick={() => onClickClose()}
							>
								<CloseIcon className="stroke-gray-900" />
								<Typography>{t(tokens.common.close)}</Typography>
							</button>
						) : (
							leftButton || avatarIcon
						)}

						{title && (
							<Typography
								variant="h6"
								className={clsx(
									avatarIcon ? "ml-2" : "absolute inset-x-0 mx-auto flex justify-center",
									"flex-1 text-gray-800",
								)}
							>
								{title}
							</Typography>
						)}

						<div>{rightButton ?? <span className="hidden">{rightButton}</span>}</div>
					</div>
				)}
				<div
					className={clsx(
						showHeader
							? transparent
								? paddingHorizontal
									? "px-4 pt-16 pb-1"
									: "pt-16 pb-1"
								: "px-4 py-5 pt-20"
							: "",
						"flex h-full flex-1 flex-col min-h-0",
					)}
				>
					{children}
				</div>
			</main>
		</motion.div>
	);
}
